var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLeftArrow({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 80,
    height: 4,
    viewBox: "0 0 80 4",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0.823227 2.17678C0.725594 2.07915 0.725594 1.92085 0.823227 1.82322L2.41422 0.232233C2.51185 0.134602 2.67014 0.134602 2.76777 0.232233C2.86539 0.329864 2.86539 0.488155 2.76777 0.585786L1.35355 2L2.76777 3.41421C2.86539 3.51184 2.86539 3.67014 2.76777 3.76777C2.67014 3.8654 2.51185 3.8654 2.41422 3.76777L0.823227 2.17678ZM80 2.25H1V1.75H80V2.25Z",
    fill: "#7A7A7C"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLeftArrow);
export default __webpack_public_path__ + "static/media/left-arrow.284850118a000ea2b2b779ca966e3d12.svg";
export { ForwardRef as ReactComponent };